<template>
  <AccountPageWrapper>
    <nuxt />
  </AccountPageWrapper>
</template>

<script>
import AccountPageWrapper from '~/components/account-page-wrapper'

export default {
  middleware: ['publicOnly', 'applicationForm'],

  components: {
    AccountPageWrapper
  }
}
</script>

<style lang="scss" scoped>
</style>
